const CoursePreviewModal = ({ file, setPreview }) => {
  const ext = file?.split('.').pop().toLowerCase()

  const renderPreview = () => {
    // video
    if (['mp4', 'webm', 'ogg', 'mov'].includes(ext)) {
      return (
        <video controls className="w-full rounded-xl mt-2">
          <source src={file} />
        </video>
      )
    }

    // audio
    if (['mp3', 'wav', 'aac', 'm4a', 'flac'].includes(ext)) {
      return (
        <audio controls className="w-full mt-2">
          <source src={file} />
        </audio>
      )
    }

    // pdf
    if (ext === 'pdf') {
      return (
        <iframe
          src={file}
          className="w-full h-[500px] rounded-xl mt-2"
          title="pdf-preview"
        />
      )
    }

    // doc / ppt / xls
    if (['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'].includes(ext)) {
      return (
        <div className="rounded-xl overflow-hidden mt-2">
          <iframe
            src={`https://docs.google.com/gview?url=${file}&embedded=true`}
            className="w-full h-[500px] border-0"
            title="doc-preview"
          />
        </div>
      )
    }

    // txt / code / unknown
    return (
      <div className="rounded-xl overflow-hidden mt-2">
        <iframe
          src={file}
          className="w-full h-[500px]"
          title="file-preview"
        />
      </div>
    )
  }

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-[1000]"
      onClick={() => setPreview(null)}
    >
      <div
        className="bg-white rounded-2xl w-[600px] max-w-[95%] max-h-[90%] overflow-auto flex flex-col shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">File Preview</h3>
              <p className="text-sm text-gray-500 mt-0.5">{file?.split('/').pop()}</p>
            </div>
          </div>
          <button
            onClick={() => setPreview(null)}
            className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Preview Content */}
        <div className="p-6">
          {renderPreview()}
        </div>

        {/* Footer */}
        {/* <div className="p-5 border-t border-gray-100 flex justify-end">
          <button
            onClick={() => setPreview(null)}
            className="px-5 py-2.5 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div> */}
      </div>
    </div>
  )
}

export default CoursePreviewModal